// pages/SARMs.jsx
import React,{useEffect} from "react";
import "./Products.css"; // Reuse same CSS

import Cardarine from "./CarouselImages/sarms/Cardarine.jpg";
import LGD4033 from "./CarouselImages/sarms/LGD4033.jpg";
import MK677 from "./CarouselImages/sarms/MK677.jpg";
import MK2866 from "./CarouselImages/sarms/MK2866.jpg";
import RAD from "./CarouselImages/sarms/RAD.jpg";
import S23 from "./CarouselImages/sarms/S23.jpg";
import SR9009 from "./CarouselImages/sarms/SR9009.jpg";

const sarms = [
  {
    name: "Cardarine",
    description: "$79",
    image: Cardarine,
  },
  {
    name: "LGD-4033",
    description: "$80",
    image: LGD4033,
  },
  {
    name: "MK-677",
    description: "$58",
    image: MK677,
  },
  {
    name: "MK-2866",
    description: "$82",
    image: MK2866,
  },
  {
    name: "RAD",
    description: "$67",
    image: RAD,
  },
  {
    name: "S-23",
    description: "$81",
    image: S23,
  },
  {
    name: "SR-9009",
    description: "$82",
    image: SR9009,
  },
];

const SARMs = () => {
  // Scroll to top on mount
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className="products-page">
      <h1>SARMs Products</h1>
      <div className="product-grid">
        {sarms.map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.image} alt={item.name} className="product-img" />
            <div className="product-info">
              <h2>{item.name}</h2>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SARMs;
